const HIPAACompliancePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">HIPAA Compliance</h1>
        <p className="text-gray-600 mb-8">Our commitment to protecting healthcare data</p>

        <div className="prose prose-lg max-w-none space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. What is HIPAA?</h2>
            <p>
              The Health Insurance Portability and Accountability Act (HIPAA) is a U.S. federal law that regulates the use and disclosure of Protected Health Information (PHI). Acuity Practice is fully committed to HIPAA compliance and maintains the standards necessary to protect patient privacy and the security of health information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Our HIPAA Commitments</h2>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Privacy Protection</h3>
            <p>
              We protect the privacy of patient information by restricting access to PHI to authorized personnel only. Patient data is segregated and accessible only to those with a legitimate business need.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Data Encryption</h3>
            <p>
              All patient data is encrypted both in transit (using TLS/SSL) and at rest using AES-256 encryption. This ensures that even if data is intercepted or accessed without authorization, it remains protected.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Access Controls</h3>
            <p>
              We implement strict access controls including user authentication, role-based permissions, and audit logging. Every access to PHI is recorded and can be audited for compliance.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Business Associate Agreements</h3>
            <p>
              All subcontractors and business associates who have access to PHI are required to sign a Business Associate Agreement (BAA) ensuring they meet HIPAA standards.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Administrative Safeguards</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Designated security officer responsible for developing and implementing security policies</li>
              <li>Regular security awareness and training for all employees</li>
              <li>Documented policies and procedures for all security-related functions</li>
              <li>Annual risk assessments and vulnerability testing</li>
              <li>Incident response procedures for potential breaches</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Physical Safeguards</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Secure data centers with restricted access and surveillance</li>
              <li>Redundant systems and backup power to ensure availability</li>
              <li>Physical controls on facility access and equipment</li>
              <li>Secure device and media controls</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Technical Safeguards</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>User authentication with strong password requirements</li>
              <li>Multi-factor authentication available for enhanced security</li>
              <li>Comprehensive audit controls and logging</li>
              <li>Automatic session timeouts</li>
              <li>Regular security patches and updates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Breach Notification</h2>
            <p>
              In the unlikely event of a breach of PHI, Acuity Practice will:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Notify affected individuals without unreasonable delay and in no case later than 60 calendar days</li>
              <li>Provide detailed information about the breach and steps affected individuals should take</li>
              <li>Notify the media and regulatory authorities as required by law</li>
              <li>Conduct a thorough investigation to prevent future breaches</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Disaster Recovery and Business Continuity</h2>
            <p>
              We maintain comprehensive disaster recovery and business continuity plans to ensure that patient data is protected and services remain available even in the event of a disaster or system failure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Compliance Verification</h2>
            <p>
              Acuity Practice undergoes regular security assessments and compliance audits to verify HIPAA compliance. We welcome inquiries from covered entities regarding our security practices and compliance status.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Contact for HIPAA Questions</h2>
            <p>
              If you have questions about our HIPAA compliance or would like to discuss a Business Associate Agreement:
            </p>
            <p>
              <strong>HIPAA Compliance Officer</strong><br />
              Acuity Practice<br />
              Trust Tech Digital<br />
              <a href="mailto:hipaa@acuitypractice.com" className="text-primary-500 hover:text-primary-600">hipaa@acuitypractice.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default HIPAACompliancePage
